import script from "./BlockDropsDescription.vue?vue&type=script&setup=true&lang=js"
export * from "./BlockDropsDescription.vue?vue&type=script&setup=true&lang=js"

import "./BlockDropsDescription.vue?vue&type=style&index=0&id=76636bb5&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-76636bb5"]])

export default __exports__